/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDatasetDetailReference,
    AIDatasetDetailReferenceFromJSON,
    AIDatasetDetailReferenceFromJSONTyped,
    AIDatasetDetailReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AICategoryDetail
 */
export interface AICategoryDetail {
    /**
     * 
     * @type {string}
     * @memberof AICategoryDetail
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AICategoryDetail
     */
    readonly annotationCount: number;
    /**
     * 
     * @type {string}
     * @memberof AICategoryDetail
     */
    readonly sampleAnnotation: string;
    /**
     * 
     * @type {string}
     * @memberof AICategoryDetail
     */
    readonly connection: string;
    /**
     * 
     * @type {AIDatasetDetailReference}
     * @memberof AICategoryDetail
     */
    dataset: AIDatasetDetailReference;
    /**
     * 
     * @type {string}
     * @memberof AICategoryDetail
     */
    name: string;
}

export function AICategoryDetailFromJSON(json: any): AICategoryDetail {
    return AICategoryDetailFromJSONTyped(json, false);
}

export function AICategoryDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AICategoryDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'annotationCount': json['annotation_count'],
        'sampleAnnotation': json['sample_annotation'],
        'connection': json['connection'],
        'dataset': AIDatasetDetailReferenceFromJSON(json['dataset']),
        'name': json['name'],
    };
}

export function AICategoryDetailToJSON(value?: AICategoryDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'dataset': AIDatasetDetailReferenceToJSON(value.dataset),
        'name': value.name,
    };
}


